// ─── Query Keys der Betreiberkonsole ────────────────────────────────────────
//
// Bewusst nur die Schlüssel, die hier gebraucht werden – die Anwendung führt
// ihr eigenes, deutlich größeres Register für Personen, Archiv, Laufbahn und
// so weiter. Beide teilen keine Caches, also müssen sie auch keine Liste
// teilen.

export const QUERY_KEYS = {
  users: {
    all: ['users'] as const,
  },

  roles: {
    all: ['roles'] as const,
    permissions: ['roles', 'permissions'] as const,
  },
} as const;
